import React from 'react';

const Footer = () => {
	return (
		<footer className="py-5 text-center h-[200px] lg:h-[250px]">
			<div className="container mx-auto">
				<div className=" text-base font-light">
					&copy; {new Date().getFullYear()} Developed with {' '}
					<span className="text-[.65em] leading-none bg-clip-text">💜</span>{' '}
					by {' '}
					<a
						className="hover:underline underline-offset-2"
						href="https://www.linkedin.com/in/gabriel-morettii/"
						target="_blank" rel="noreferrer"
					>
						Gabriel Moretti
					</a>
				</div>
			</div>
		</footer>
	);
};

export default Footer;
